module.exports = __webpack_public_path__ + "img/DSC_2746-xl.49daf520.png";